import {
  ExamFilter,
  getExam,
  listExams,
} from '@/data/services/examServices';

export const examQueries = {
  all: ['exams'] as const,

  get: (id: number) => ({
    queryKey: [...examQueries.all, 'get', id] as const,
    queryFn: () => getExam(id),
  }),

  list: (filters: ExamFilter = {}) => ({
    queryKey: [...examQueries.all, 'list', { filters }] as const,
    queryFn: () => listExams(filters),
  }),

  listInfinite: (filters: ExamFilter = {}) => ({
    queryKey: [...examQueries.list(filters).queryKey, 'infinite'] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listExams({ ...filters, pageNumber: ctx.pageParam }),
  }),
};
